"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var targetSelection = {
  id: "targetSelection",
  title: {
    en: "Target selection",
    de: "Zielauswahl"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Target selection"), /*#__PURE__*/_react.default.createElement("p", null, "Generally use your mouse to wanted target and then L-Click (mouse left click) and it will be selected and target bar will be targeted."), /*#__PURE__*/_react.default.createElement("p", null, "Other than the mouse in ferentus, keyboard mode uses shortcut keys to easily select and use."), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "PC (Player character: User character) select"), "Shortcut key F6 will select nearest PC in order.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "NPC(Non Player Character)select"), "Shortcut key F7 to select nearest NPC in order.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Selecting all characters"), "With shortcut key F8, you can select nearest PC or NPC.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Self select"), "Shortcut key F9 can select yourself.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Party member select."), /*#__PURE__*/_react.default.createElement("p", null, "At the party window click on party member slot, party member can be targeted."), /*#__PURE__*/_react.default.createElement("p", null, "At the option window's change shortcut key, you can shortcut key to select 1~7 party members. In default nothing is selected and if you want to use shortcut key to use.")))))
  }
};
var _default = targetSelection;
exports.default = _default;